import {
	IconInstagramColored,
	IconNaverBlogColored,
	IconTiktokColored,
	IconXColored,
	IconYoutubeColored,
} from '@featuring-corp/icons';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef, createElement } from 'react';

import { iconWrapperClass } from './style.css';
import { PlatformCode } from 'src/type/common';

export interface SnsRoundedProps extends ComponentPropsWithoutRef<'div'> {
	platformCode?: PlatformCode;
}

const SnsRounded = ({ platformCode, className, ...props }: SnsRoundedProps) => {
	const iconMapper = {
		ig: IconInstagramColored,
		yt: IconYoutubeColored,
		nb: IconNaverBlogColored,
		tt: IconTiktokColored,
		tw: IconXColored,
	} as const;

	return (
		<div className={clsx(iconWrapperClass, className)}>
			{platformCode && createElement(iconMapper[platformCode], { size: 14 })}
		</div>
	);
};

export default SnsRounded;
